module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h3', {
    staticClass: "header"
  }, [_vm._v("Welcome to the updated Opentrons APIv2 Protocol Library!")]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "content-copy"
  }, [_vm._v("New to the Protocol Library? A great place to start is to determine whether your lab’s workflow can be handled with our with our Featured or Verified protocols found on the left-hand side of the library.")]), _vm._v(" "), _c('p'), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _c('p'), _vm._v(" "), _c('h2', [_vm._v("Featured")]), _vm._v(" "), _c('p', {
    staticClass: "content-copy"
  }, [_vm._v("A majority of lab workflows can be performed with protocols found in the Featured section of the Protocol Library. Find Cherrypicking, Normalization, and Serial Dilution protocols with customizable parameters to fit your lab’s needs.")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "content-copy"
  }, [_vm._v("Our NGS Library Prep protocols which utilize the popular Illumina Nextera XT and Swift 2s Turbo Kits are also hosted here.")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('h2', [_vm._v("Verified")]), _vm._v(" "), _c('p', {
    staticClass: "content-copy"
  }, [_vm._v("Opentrons Verified protocols are protocols which have been extensively tested on the OT-2 by our in-house science team. Look for the “App Note” link in the following protocols to find more information on results and analysis using the OT-2.")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('ul', {
    staticClass: "content-copy"
  }, [_c('lh', [_vm._v("Our Opentrons Verified protocols can be found below:")]), _vm._v(" "), _vm._m(2, false, false), _vm._m(3, false, false), _vm._m(4, false, false), _vm._v(" "), _vm._m(5, false, false)], 1), _vm._v(" "), _c('p', {
    staticClass: "content-copy"
  }, [_vm._v("If your lab’s workflow isn’t satisfied with these protocols, feel free to explore our other categorized protocols also found on the left-hand side of the library. You can also try using our search bar.")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content-copy"
  }, [_vm._v("All OT-2 compatible workflows including our Featured and Verified protocols can be found here in the Protocol Library. All protocols in the Protocol Library are written using Version 2 of the Opentrons OT-2 Python API. Learn more about OT-2 Python Protocol API Version 2\n      "), _c('a', {
    attrs: {
      "href": "https://docs.opentrons.com",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("here")]), _vm._v(".\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content-copy"
  }, [_vm._v("Still didn’t find what you’re looking for? Feel free to reach out to your customer success manager to determine whether\n      "), _c('a', {
    attrs: {
      "href": "https://designer.opentrons.com",
      "target": "_blank",
      "rel": "nooper noreferrer"
    }
  }, [_vm._v("Protocol Designer")]), _vm._v(" or Custom Protocol Development is right for you.\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "list-el"
  }, [_c('a', {
    attrs: {
      "href": "https://protocols.opentrons.com/protocol/swift-fully-automated",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("Swift 2S Turbo DNA Library Kit Protocol: Fully-Automated")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "list-el"
  }, [_c('a', {
    attrs: {
      "href": "https://protocols.opentrons.com/protocol/swift-2s-turbo-pt1",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("Swift 2S Turbo DNA Library Kit Protocol: Semi-Automated")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "list-el"
  }, [_c('a', {
    attrs: {
      "href": "https://protocols.opentrons.com/protocol/omega_biotek_magbind_totalpure_NGS",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("NGS Cleanup and Size Selection with Omega Bio-tek Mag-Bind® TotalPure NGS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "list-el"
  }, [_c('a', {
    attrs: {
      "href": "https://protocols.opentrons.com/protocol/pcr_prep_part_1",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("OT-2 PCR Prep")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2d42c617!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UpdateBanner.vue
// module id = 237
// module chunks = 2